import { createElement } from "react";
/**
 * Internal Dependencies
 */
import FieldAction from '../field-action';
import { __experimentalUseFieldRenderContext } from '../field-render';
import SubmitBtn from '../submit-btn';
const NonEditableBlockFooter = () => {
  const {
    next,
    isLastField
  } = __experimentalUseFieldRenderContext();
  return createElement("div", {
    className: "renderer-components-block-footer"
  }, isLastField ? createElement(SubmitBtn, null) : createElement(FieldAction, {
    show: true,
    clickHandler: () => {
      next();
    }
  }));
};
export default NonEditableBlockFooter;
//# sourceMappingURL=non-editable.js.map